import React, { useState } from "react";
import { Star } from "lucide-react";

/**
 * Simple 1..5 star rating input. Controlled via `value` (int) and `onChange`.
 * If readOnly, renders a static row (used to display averages elsewhere).
 */
export function StarRating({ value = 0, onChange, size = 22, readOnly = false, testIdPrefix = "star" }) {
    const [hover, setHover] = useState(0);
    const active = hover || value;
    return (
        <div className="inline-flex items-center gap-1" role="radiogroup">
            {[1, 2, 3, 4, 5].map((n) => (
                <button
                    key={n}
                    type="button"
                    disabled={readOnly}
                    onMouseEnter={() => !readOnly && setHover(n)}
                    onMouseLeave={() => !readOnly && setHover(0)}
                    onClick={() => !readOnly && onChange && onChange(n)}
                    className={`transition-transform ${readOnly ? "cursor-default" : "hover:scale-110 cursor-pointer"}`}
                    aria-label={`${n} sur 5`}
                    data-testid={`${testIdPrefix}-${n}`}
                >
                    <Star
                        size={size}
                        strokeWidth={1.5}
                        className={
                            n <= active
                                ? "text-[#F5A623] fill-[#F5A623]"
                                : "text-slate-300"
                        }
                    />
                </button>
            ))}
        </div>
    );
}

export default StarRating;
